import {createMuiTheme, responsiveFontSizes} from "@material-ui/core/styles";

// colors
const primary = "#ED3237";
const secondary = "#ED3237";
const black = "#343a40";
const darkBlack = "rgb(36, 40, 44)";
const background = "#f5f5f5";

const correctMain = "#32bd20";
const wrongMain = "#ff0000";

const theme = createMuiTheme({
    palette: {
        primary: { main: primary },
        secondary: { main: secondary },
        background: {
            default: background
        },
        common: {
            black,
            darkBlack
        },
        correct: {
            main: correctMain,
        },
        wrong: {
            main: wrongMain,
        }
    },
    spacing: factor => `${0.25 * factor}rem`,
    overrides: {
        MuiListItem: {
            root: {
                paddingBottom:0,
                paddingTop:0,
            },
        },
        MuiCard: {
            root: {
                marginBottom:20,
                borderRadius:5
            }
        },
    },
    typography: {
        h2: {
            fontSize:32,
            color: primary,
            paddingBottom: 20
        },
        h5: {
            fontSize: 18,
            lineHeight:1.25,
        },
        h6: {
            fontSize: 16,
            lineHeight:1.25,
        },
        body1: {
            fontSize: 17,
        },
        body2: {
            fontSize: 14,
        }
    },
    rootPadding:10

});

export default responsiveFontSizes(theme);